import { getStrWithoutSpaces } from 'legacy/lut/components/widgets/public/partner360/helpers/getStrWithoutSpaces'

import { SegmentedControl } from 'cng-common/components/segmentedControl'
import { Translation } from 'cng-common/features/translations'

interface IStrategicInitiativesOfferingProps {
  offerings: string[]
  offering: string
  onChange: (offering: string) => void
}

export const StrategicInitiativesOffering = ({
  offerings,
  offering,
  onChange,
}: IStrategicInitiativesOfferingProps) => {
  if (!offerings.length) {
    return null
  }

  return (
    <SegmentedControl useItemKeys selectedItem={offering} onItemSelect={onChange}>
      {offerings.map((item) => (
        <SegmentedControl.Item key={item} itemKey={item}>
          <Translation span text={`jbp-partner-type-${getStrWithoutSpaces(item)}`} />
        </SegmentedControl.Item>
      ))}
    </SegmentedControl>
  )
}

StrategicInitiativesOffering.displayName = 'StrategicInitiativesOffering'
